import axios from "axios";
import createRestApiClient from "../../utility/createRestApiClient";

import { getCookieData } from "../../utility/cookieHandler/handler";
import {
  CLEAR_ARCHIVES_PAGINATION_DATA,
  CYPRESS_TEST_COUNT_LOADING,
  CYPRESS_TEST_COUNT_SUCCESS,
  CYPRESS_TEST_COUNT_FAILED,
  DELETE_TEST,
  FETCH_FLAXY_TESTS_LIST_FAILED,
  FETCH_FLAXY_TESTS_LIST_LOADING,
  FETCH_FLAXY_TESTS_LIST_SUCCESS,
  LAMBDATEST_RENAME_TEST_FAILED,
  LAMBDATEST_RENAME_TEST_LOADING,
  LAMBDATEST_RENAME_TEST_SUCCESS,
  LAMBDATEST_TEST_LIST_DATA_UPDATE_LIST,
  LAMBDATEST_UPDATE_TEST_NAME_STATUS,
  TEST_ARCHIVES_PAGINATION_FAILED,
  TEST_ARCHIVES_PAGINATION_LOADING,
  TEST_ARCHIVES_PAGINATION_SUCCESS,
  TEST_ARCHIVES_SET_IS_SHARE_MODAL_VISIBLE,
  TEST_MUTE_STATUS_UPDATE
} from "../actionTypeConstants/TestArchives";

import { DEFAULT_TEST_DATA_API_CALL_LIMIT } from "../../common/constants/View";
import { getFlakyRequestBody } from "../../utility/testHelpers";
import { getApiBaseUrl } from "../../utility/utilityFunctions";
import cloneDeep from "lodash/cloneDeep";

const CancelToken = axios.CancelToken;
let source;

const getQueryString = (filter, newPagination) => {
  let queryString = "";
  Object.keys(filter).forEach(k => {
    if (filter[k]) {
      if (filter[k] instanceof Array) {
        if (filter[k].length > 0) {
          if (k === "range" && !filter.filterBy) {
            queryString = `${queryString}&${k}=${filter[k].join(",")}`;
          } else if (k === "build" && !newPagination) {
            // Pass 'buildName' as the key, as we're storing the name of the build in redux store corresponding to build
            // and BE supports queryParam 'buildName' for the same.
            queryString = `${queryString}&buildName=${filter[k].join(",")}`;
          } else if (k === "buildName") {
            queryString = `${queryString}&buildName=${encodeURIComponent(
              filter[k].join(",")
            )}`;
          } else {
            queryString = `${queryString}&${k}=${filter[k].join(",")}`;
          }
        }
      }
      if (typeof filter[k] === "string" || filter[k] instanceof String) {
        if (filter[k].trim() !== "") {
          if (k === "build" && !newPagination) {
            // Pass 'buildName' as the key, as we're storing the name of the build in redux store corresponding to build
            // and BE supports queryParam 'buildName' for the same.
            queryString = `${queryString}&buildName=${filter[k]}`;
          } else {
            queryString = `${queryString}&${k}=${filter[k]}`;
          }
        }
      }
    }
  });
  return queryString;
};

export function setShowShareTestModal(isVisible) {
  return dispatch =>
    dispatch({
      payload: isVisible,
      type: TEST_ARCHIVES_SET_IS_SHARE_MODAL_VISIBLE
    });
}

export const updateTestNameAndStatus = data => {
  return dispatch =>
    dispatch({
      type: LAMBDATEST_UPDATE_TEST_NAME_STATUS,
      payload: data
    });
};

export const updateTestLists = testList => (dispatch: Dispatch) => {
  dispatch({
    type: LAMBDATEST_TEST_LIST_DATA_UPDATE_LIST,
    payload: testList
  });
};

export const renameTest = (testId, data, automationApiHost) => {
  if (!testId) {
    return false;
  }

  const mockApiEndpoint = automationApiHost || getApiBaseUrl();
  const mockApiClient = createRestApiClient().withConfig({
    baseURL: mockApiEndpoint
  }).client;
  let cookieName = process.env.REACT_APP_COOKIE_NAME;
  let access_token = getCookieData(cookieName);
  if (!access_token) {
    window.location.href =
      process.env.REACT_APP_LOGIN_URL || window?._env_?.REACT_APP_LOGIN_URL;
  }
  let types = [
    LAMBDATEST_RENAME_TEST_LOADING,
    LAMBDATEST_RENAME_TEST_SUCCESS,
    LAMBDATEST_RENAME_TEST_FAILED
  ];
  const endPoint = `api/v1/test/${testId}/updatename`;
  let headers = {
    Authorization: `Bearer ${access_token}`,
    Accept: "application/json"
  };

  return {
    types: types,
    promise: () =>
      mockApiClient.put(
        `${endPoint}`,
        {
          name: data
        },
        {
          headers: headers
        }
      )
  };
};

export function fetchTestArchivesPagination({
  token,
  filter = [],
  offset = 0,
  limit = DEFAULT_TEST_DATA_API_CALL_LIMIT,
  automationApiHost,
  isNewCypressTestView = false
}) {
  let filterToApply = cloneDeep(filter);

  let browserFilter = filterToApply["browser"];
  if (browserFilter && browserFilter?.length > 0) {
    const isEdgeAppliedIndex = browserFilter.findIndex(name => name === "edge");
    if (isEdgeAppliedIndex > -1) {
      filterToApply["browser"][isEdgeAppliedIndex] = "MicrosoftEdge";
    }
  }

  let queryString = getQueryString(filterToApply, true);

  const newTestViewParam = isNewCypressTestView ? "&newTestView=true" : "";

  const mockApiEndpoint = automationApiHost || getApiBaseUrl();
  const mockApiClient = createRestApiClient().withConfig({
    baseURL: mockApiEndpoint
  }).client;

  const cookieName = process.env.REACT_APP_COOKIE_NAME;
  const accessToken = getCookieData(cookieName) || token;
  if (!accessToken) {
    window.location.href = process.env.REACT_APP_LOGIN_URL;
  }
  if (source) {
    source.cancel();
  }
  if (
    queryString.includes("searchText=") &&
    !queryString.includes("searchText=testId:") &&
    !queryString.includes("searchText=sessionId:")
  ) {
    queryString = queryString.replace("searchText=", "searchText=testName:");
  }
  source = CancelToken.source();
  const header = {
    Authorization: `Bearer ${accessToken}`
  };
  const timezoneOffset = getCookieData("timezoneOffset");
  let endPoint = `/api/v2/test?timezone=${timezoneOffset}&offset=${offset}&limit=${limit}&${queryString}&includeCreated=0&caps=1${newTestViewParam}`;

  // Only fetch the total count incase user is on first page i.e first load.
  if (offset === 0) {
    endPoint = endPoint + `&countEnable=true`;
  }
  // if (queryString.includes("searchText=testName:")) {
  //   endPoint = `${endPoint}&analyticsSearchEnable=true&archivePage=true`;
  // }
  const typesArray = [
    TEST_ARCHIVES_PAGINATION_LOADING,
    TEST_ARCHIVES_PAGINATION_SUCCESS,
    TEST_ARCHIVES_PAGINATION_FAILED
  ];

  return {
    payload: {
      offset
    },
    types: [...typesArray],
    promise: () =>
      mockApiClient.get(endPoint, {
        headers: header,
        cancelToken: source.token
      })
  };
}

export function fetchCypressTestCount({
  token,
  buildId = "",
  filter = [],
  limit = 25,
  automationApiHost
}) {
  let filterToApply = cloneDeep(filter);

  let browserFilter = filterToApply["browser"];
  if (browserFilter && browserFilter?.length > 0) {
    const isEdgeAppliedIndex = browserFilter.findIndex(name => name === "edge");
    if (isEdgeAppliedIndex > -1) {
      filterToApply["browser"][isEdgeAppliedIndex] = "MicrosoftEdge";
    }
  }

  let queryString = getQueryString(filterToApply, true);

  const mockApiEndpoint = automationApiHost || getApiBaseUrl();
  const mockApiClient = createRestApiClient().withConfig({
    baseURL: mockApiEndpoint
  }).client;

  const cookieName = process.env.REACT_APP_COOKIE_NAME;
  const accessToken = getCookieData(cookieName) || token;
  if (!accessToken) {
    window.location.href = process.env.REACT_APP_LOGIN_URL;
  }
  if (source) {
    source.cancel();
  }
  if (
    queryString.includes("searchText=") &&
    !queryString.includes("searchText=testId:") &&
    !queryString.includes("searchText=sessionId:")
  ) {
    queryString = queryString.replace("searchText=", "searchText=testName:");
  }
  source = CancelToken.source();
  const header = {
    Authorization: `Bearer ${accessToken}`
  };
  const timezoneOffset = getCookieData("timezoneOffset");
  let endPoint = `/api/v2/test?timezone=${timezoneOffset}&offset=0&limit=${limit}&${queryString}&build=${buildId}&includeCreated=0&caps=1&newTestView=true&countEnable=true`;

  const typesArray = [
    CYPRESS_TEST_COUNT_LOADING,
    CYPRESS_TEST_COUNT_SUCCESS,
    CYPRESS_TEST_COUNT_FAILED
  ];

  return {
    types: [...typesArray],
    promise: () =>
      mockApiClient.get(endPoint, {
        headers: header,
        cancelToken: source.token
      })
  };
}

export const deleteTest = id => {
  return dispatch =>
    dispatch({
      payload: id,
      type: DELETE_TEST
    });
};

export const clearTestAchivePaginationData = () => (dispatch: Dispatch) => {
  dispatch({
    type: CLEAR_ARCHIVES_PAGINATION_DATA,
    result: null
  });
};

export const fetchFLakyDetails = (testList, isAppend) => {
  const mockApiEndpoint = getApiBaseUrl();
  const mockApiClient = createRestApiClient().withConfig({
    baseURL: mockApiEndpoint
  }).client;
  const cookieName = process.env.REACT_APP_COOKIE_NAME;
  const access_token = getCookieData(cookieName);

  const types = [
    FETCH_FLAXY_TESTS_LIST_LOADING,
    FETCH_FLAXY_TESTS_LIST_SUCCESS,
    FETCH_FLAXY_TESTS_LIST_FAILED
  ];
  const headers = {
    Authorization: `Bearer ${access_token}`,
    Accept: "application/json"
  };

  const body = getFlakyRequestBody(testList);

  const endPoint = "/insights/api/v3/data?traceId=ml-ftd-testList";
  return {
    types: types,
    payload: {
      isAppend
    },
    promise: () =>
      mockApiClient.post(endPoint, body, {
        headers: headers
      })
  };
};

export const updateTestMuteStatus = (testId, isMuted) => {
  return dispatch =>
    dispatch({
      type: TEST_MUTE_STATUS_UPDATE,
      payload: { testId, isMuted }
    });
};
